import { useQuery } from "@hooks/useQuery";
import { Icon } from "@iconify/react";
import { Button, Tabs } from "antd";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { PageContent } from "./PageContent/PageContent";
import { PageHeading } from "./PageHeading/PageHeading";

export const Help = () => {
  const query = useQuery();
  const activeTab = query.get("activeTab");
  const navigate = useNavigate();

  useEffect(() => {
    if (!activeTab) {
      navigate(`/dedicated/passenger/help/?activeTab=pageHeading`, {
        replace: true,
      });
    }
  }, [activeTab, navigate]);

  const tabItems = [
    {
      label: "Page Heading",
      key: "pageHeading",
      children: <PageHeading />,
    },
    {
      label: "Page Content",
      key: "pageContent",
      children: <PageContent />,
    },
  ];

  const handleActionButton = (tabKey: string) => {
    switch (tabKey) {
      case "pageContent":
        return (
          <Button
            onClick={() => navigate("/dedicated/passenger/help/pageContent/add")}
            icon={<Icon icon="lucide:plus" />}
          >
            Add Page Content
          </Button>
        );
      default:
        return null;
    }
  };

  return (
    <ContentWrapper
      title="Help"
      bodyStyle={{ height: "calc(100vh - 100px)", overflowY: "auto" }}
      actionItems={handleActionButton(activeTab || "airport")}
    >
      <Tabs
        activeKey={activeTab || "pageContent"}
        items={tabItems}
        onChange={(key) => navigate(`${window.location.pathname}?activeTab=${key}`)}
      />
    </ContentWrapper>
  );
};
